export const crms_selectCrmsLoading = (state) => state.crms.crmsLoading
export const crms_selectCrms = (state) => state.crms.crms
export const crms_selectCrmData = (state) => state.crms.crmData